import { negativeNumbersRegex, onlyNumbersRegex } from 'modules/validation';
import React from 'react';
import { Controller, UseFormReturn, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { FieldWrapper } from 'shared/components';
import { isZeroBeforeDot } from 'shared/utils';

interface Props {
  index: number;
  control: UseFormReturn<PublishStatusAware<Proposal>>['control'];
  formState: UseFormReturn<PublishStatusAware<Proposal>>['formState'];
  value?: number;
}

export const PricePerUnitInput: React.FC<Props> = ({
  control,
  formState: { errors },
  index,
  value,
}) => {
  const { formatMessage } = useIntl();
  const isInvoice = useWatch({ name: 'isInvoice', control });

  function handleWheelCapture(event: React.WheelEvent<HTMLInputElement>) {
    if (document.activeElement === event.currentTarget) {
      event.currentTarget.blur();
    }
  }

  return (
    <FieldWrapper
      name={`segments.${index}.pricePerUnit`}
      labelId="inputs.price.label"
      isRequired
      errors={errors}
    >
      <Controller
        name={`segments.${index}.pricePerUnit`}
        control={control}
        rules={{
          required: formatMessage({ id: 'inputs.price.required' }),
          pattern: {
            value: isInvoice ? negativeNumbersRegex : onlyNumbersRegex,
            message: formatMessage({ id: 'inputs.price.invalid' }),
          },
          validate: (value) => {
            if (isZeroBeforeDot(String(value))) {
              return formatMessage({ id: 'inputs.price.starts-with-zero' });
            }
            return;
          },
        }}
        defaultValue={value}
        render={({ field: { onChange, ...field }, fieldState }) => (
          <input
            {...field}
            onChange={(e) =>
              onChange(e.target.value === '' ? '' : Number(e.target.value))
            }
            onWheelCapture={handleWheelCapture}
            inputMode="decimal"
            type="number"
            step="any"
            min={isInvoice ? undefined : 0}
            className={`input input__med input__box ${
              fieldState.error ? 'input__box__error' : ''
            }`}
            placeholder={formatMessage({ id: 'inputs.price.placeholder' })}
            data-cy={`builder-unit-price-input-${index}`}
          />
        )}
      />
    </FieldWrapper>
  );
};
